const { caixaOperationType, accountType, personType } = require('@transfeeradev/api-enums');
const PersonTypeService = require('./PersonTypeService');

class CaixaService {
  static formatAccount(account) {
    account = account ? String(account) : '';

    const accountNumber = Number(account).toString();

    if (accountNumber.length > 8) {
      const caixaOps = Object.keys(caixaOperationType).map(v => Number(caixaOperationType[v]));
      const accountValue = accountNumber.substring(accountNumber.length - 8, accountNumber.length);
      const accountStart = Number(accountNumber.replace(accountValue, ''));

      if (caixaOps.includes(accountStart)) {
        account = accountValue;
      }
    }

    return account;
  }

  static getOperationType(dba) {
    const cpfCnpj = dba.cpf_cnpj;

    if (dba.account_type === accountType.CONTA_FACIL) {
      return caixaOperationType.CONTA_FACIL;
    } else if (dba.account_type === accountType.ENTIDADES_PUBLICAS) {
      return caixaOperationType.ENTIDADES_PUBLICAS;
    } else {
      if (PersonTypeService.getType(cpfCnpj) === personType.PHYSICAL) {
        if ([accountType.CONTA_CORRENTE, accountType.CONTA_PAGAMENTO].includes(dba.account_type)) {
          return caixaOperationType.CONTA_CORRENTE_PESSOA_FISICA;
        } else {
          return caixaOperationType.POUPANCA;
        }
      } else {
        if ([accountType.CONTA_CORRENTE, accountType.CONTA_PAGAMENTO].includes(dba.account_type)) {
          return caixaOperationType.CONTA_CORRENTE_PESSOA_JURIDICA;
        } else {
          return caixaOperationType.POUPANCA_PESSOA_JURIDICA;
        }
      }
    }
  }

  static getAccountTypeFromOperationType(operation) {
    if (
      operation === caixaOperationType.CONTA_CORRENTE_PESSOA_FISICA ||
      operation === caixaOperationType.CONTA_CORRENTE_PESSOA_JURIDICA
    ) {
      return accountType.CONTA_CORRENTE;
    } else if (operation === caixaOperationType.POUPANCA || operation === caixaOperationType.POUPANCA_PESSOA_JURIDICA) {
      return accountType.CONTA_POUPANCA;
    } else if (operation === caixaOperationType.CONTA_FACIL) {
      return accountType.CONTA_FACIL;
    } else if (operation === caixaOperationType.ENTIDADES_PUBLICAS) {
      return accountType.ENTIDADES_PUBLICAS;
    }
  }
}

module.exports = CaixaService;
